import { SecuritySettings } from "@/components/settings/SecuritySettings";
import { Lock, ShieldCheck } from "lucide-react";

export function SecuritySection() {
  return (
    <div className="space-y-5">
      {/* Security status callout */}
      <div className="rounded-xl border border-success/20 bg-success/5 p-4 sm:p-5 flex items-start gap-4">
        <div className="h-11 w-11 rounded-xl bg-success/10 border border-success/20 flex items-center justify-center shrink-0">
          <ShieldCheck className="h-5 w-5 text-success" />
        </div>
        <div>
          <h3 className="font-semibold text-sm">Your account is secure</h3>
          <p className="text-sm text-muted-foreground mt-0.5">
            Microsoft OAuth protects your sign-in. You can additionally set or change a password below.
          </p>
        </div>
      </div>

      {/* Password section wrapper */}
      <div className="rounded-xl border border-border/60 bg-card overflow-hidden">
        <div className="p-5 sm:p-6 border-b border-border/60 flex items-start gap-4">
          <div className="h-11 w-11 rounded-xl bg-muted flex items-center justify-center shrink-0">
            <Lock className="h-5 w-5 text-muted-foreground" />
          </div>
          <div>
            <h3 className="font-semibold">Password</h3>
            <p className="text-sm text-muted-foreground mt-1">
              Optional. Use a strong, unique password if you want to enable email/password sign-in.
            </p>
          </div>
        </div>
        <div className="p-5 sm:p-6">
          <SecuritySettings />
        </div>
      </div>
    </div>
  );
}
